<template>
  <div>
    <div class="text-center">
      <div class="period-rent-item" @click="update">
        <DisplayPeriodRent fontSize="14" :periodRent="periodRent" />
      </div>
    </div>
  </div>
</template>
<script>
import Modal from "@nixweb/nixloc-ui/src/component/forms/Modal";
import DisplayPeriodRent from "@nixweb/nixloc-ui/src/component/rental/DisplayPeriodRent";

import { mapGetters, mapMutations } from "vuex";

export default {
  name: "PeriodRentItem",
  components: {
    Modal,
    DisplayPeriodRent,
  },
  data() {
    return {
      periodRent: {},
    };
  },
  computed: {
    ...mapGetters("generic", ["event", "showModal"]),
  },
  methods: {
    ...mapMutations("generic", ["addEvent", "openModal"]),
    update() {
      this.addEvent({
        name: "clickedPeriodRentItem",
        data: this.periodRent,
      });
    },
  },
  watch: {
    event: {
      handler(event) {
        if (event.name == "generatePeriodRent") this.periodRent = event.data;
      },
      deep: true,
    },
  },
};
</script>
<style scoped>
.period-rent-item {
  display: inline-block;
  cursor: pointer;
  background-color: #F9FAFB;
  border: 1px solid #e5e4e8;
  border-radius: 50px;
  padding: 8px 14px;
  font-weight: normal;
  transition: all 0.2s ease;
}

.text-center {
  text-align: center;
}
</style>
